export function formatAge(birthDate, language = 'en') {
  if (!birthDate) return null;
  const now = new Date();
  const birth = new Date(birthDate);
  const totalMonths =
    (now.getFullYear() - birth.getFullYear()) * 12 +
    (now.getMonth() - birth.getMonth()) +
    (now.getDate() < birth.getDate() ? -1 : 0);
  const months = Math.max(0, totalMonths);

  if (months >= 12) {
    const yrs = Math.floor(months / 12);
    return language === 'es'
      ? `${yrs} ${yrs === 1 ? 'año' : 'años'}`
      : `${yrs} ${yrs === 1 ? 'year' : 'years'}`;
  }
  if (months >= 1) {
    return language === 'es'
      ? `${months} ${months === 1 ? 'mes' : 'meses'}`
      : `${months} ${months === 1 ? 'month' : 'months'}`;
  }
  return language === 'es' ? 'menos de 1 mes' : 'less than 1 month';
}
